import React, { useState, useEffect  } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import elLocale from '@fullcalendar/core/locales/el';
import '../css/Popup.css'
import EventService from "./EventService";
import '../css/Calendar.css'
import FilesPage from "./FileList";
import WeatherForecast from "./WeatherForecast";
import ExportButton from "./ExportButton";
import WeatherGraph from "./WeatherGraph";


function Calendar(props) {
  const { preferredUsername } = props;
  const [isOpen, setIsOpen] = useState(false);
  const [isModified, setIsModified] = useState(false);
  const [eventId, setEventId] = useState(null);
  const [selectedDate, setSelectedDate] = useState(false);
  const [events, setEvents] = useState([]); 

  const [cupt, setCupt] = useState('Αμπέλι');
  const [loc, setLoc] = useState('Ζευγολατιό');
  const [evn, setEvn] = useState('Βροχή');
  const [comm, setComm] = useState('');
  const [start, setStart] = useState('');
  const [selectedFile, setSelectedFile] = useState(null);
  const [selectedVillage, setSelectedVillage] = useState('');
  const [showWeatherGraph, setShowWeatherGraph] = useState(false);

  const handleButtonClick = () => {
    setShowWeatherGraph(!showWeatherGraph);
  };

  const handleVillageChange = (village) => {
    setSelectedVillage(village);
  };

  const handleCuptChange = (event) => {
    setCupt(event.target.value);
  };

  const handleLocChange = (event) => {
    setLoc(event.target.value);
  };

  const handleEvnChange = (event) => {
    setEvn(event.target.value);
  };

  const handleCommChange = (event) => {
    setComm(event.target.value);
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setSelectedFile(file);
  };

  const handleCreateClick = () => {
    setIsOpen(true);
    setCupt('Αμπέλι');
    setLoc('Ζευγολατιό');
    setEvn('Βροχή');
    setComm('');
    setSelectedDate('');
  };

  const handleCloseClick = () => {
    setIsOpen(false);
  };

  const handleSaveClick = () => {
    if (selectedDate) {
      const newEvent = {
        title: evn,
        start: selectedDate,
        backgroundColor: "#007acc",
        textColor: "#fff",
      };
      setIsOpen(false);
      setSelectedDate(null);
      setEvents([...events, newEvent]); // Update the events array with the new event
      const data = { 
        "username": preferredUsername,
        "cultivation": cupt,
        "location": loc,
        "events": evn,
        "comments": comm,
        "starts": selectedDate
      };
      EventService.createEvent(data, selectedFile).then(response => {
        console.log('Event created successfully:', response.data);
        window.location.reload();
      })
      .catch(error => {
        console.error('Failed to create event:', error);
      });
    }
  };

  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };


  useEffect(() => {
    getEvents(preferredUsername);
  }, [preferredUsername]);

  function getEvents() {
    //console.log('When is in Calendar Preferred Username:', preferredUsername);
    EventService.getEventsByUser(preferredUsername)
      .then((response) => {
        const eventsData = response.data.map((event) => {
          //const id = event._id ? event._id.toString() : null;
          //console.log(event.id);
          return {
            id: event.id,
            title: event.events || '',
            cultivation: event.cultivation,
            location: event.location,
            comments: event.comments,
            start: event.starts,
            file: event.selectedFile,
            backgroundColor: "#007acc",
            textColor: "#fff"
          };
        });
        setEvents(eventsData);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  function handleEventClick(info) {
    setIsModified(true);
    setEventId(info.event.id);
    //Ama den douleuei afaireite
    //setEventId(info.event.id);
    const event = events.find(e => e.id === info.event.id);
    if (event) {
      setCupt(event.start)
      setCupt(event.cultivation);
      setLoc(event.location);
      setEvn(event.title);
      setComm(event.comments);
      setSelectedDate(event.start);
      setSelectedFile(event.file);
    }
  };

  function handleCloseClick2() {
    setIsModified(false);
  };

  function handleDeleteClick(id){
    EventService.deleteEvent(eventId)
    .then((response) => {
    // Remove the event from the events array
      //setEvents(events.filter(event => eventId !== eventId));
      console.log('Event deleted successfully:', response.data);
      window.location.reload();
    })
      .catch((err) => {
        console.error('Failed to update event:', err);
    });
    setIsModified(false);
  }

  function handleUpdateClick(id){
    //console.log(eventId)
    if (selectedDate) {
      const newEvent = {
        title: evn,
        start: selectedDate,
        backgroundColor: "#007acc",
        textColor: "#fff",
      };
      setIsModified(false);
      setSelectedDate(null);
      setEvents([...events, newEvent]); // Update the events array with the new event
      const data = { 
        "starts": start,
        "cultivation": cupt,
        "location": loc,
        "events": evn,
        "comments": comm,
        "starts": selectedDate
      };
      EventService.updateEvent(eventId,data,selectedFile).then(response => {
        console.log('Event updated successfully:', response.data);
        window.location.reload();
      })
      .catch(error => {
        console.error('Failed to update event:', error);
      });
    }
  };

  const [showFiles, setShowFiles] = useState(false);
  const handleShowFiles  = () => {
    setShowFiles(true);
  };
  const handleCloseFiles = () => {
    setShowFiles(false);
  };

  return (
    <div>
      <div className="container">
        <div className="sidebar">
          <div className="logo">
            <img src="sodasense_icon.png" alt="Logo" />
            <span className="logo-text">Ημερολόγιο</span>
          </div>
          <ul className="nav-menu">
            <li className="nav-item">
              <button className="create-button" onClick={handleCreateClick}>
                Δημιουργία Συμβάντος
              </button>
            </li>
            <li className="nav-item">
            <button className="create-button" onClick={handleShowFiles}>Προβολή Αποθηκευμένων Εικόνων</button>
              {showFiles && (
                <FilesPage preferredUsername={preferredUsername} onClose={handleCloseFiles} />
              )}
            </li>
            <li>
                <button className="create-button" onClick={() => handleVillageChange('Καιρός')}>
                  Πρόγνωση Καιρού
                </button>
              {selectedVillage && (
                <WeatherForecast location={selectedVillage} onClose={() => setSelectedVillage('')} />
              )}
            </li>
            <li>
            <button className="create-button" onClick={handleButtonClick}>Προβολή Στατιστικών</button>
            {showWeatherGraph && (
              <WeatherGraph username={preferredUsername} onClose={() => setShowWeatherGraph(false)} />
            )}
            </li>
            <li>
              <ExportButton username={preferredUsername} />
            </li>
          </ul>
        </div>
        <div className="calendar">
          <FullCalendar
            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
            initialView="dayGridMonth"
            events={events}
            eventClick={handleEventClick}
            locale={elLocale}
          />
        </div>
      </div>
      {isOpen && (
        <div className="popup">
          <h3>Καταγραφή Συμβάντος</h3>
          <label>Ημερομηνία:</label>
          <input type="date" value={selectedDate} onChange={handleDateChange} />
          <label>Καλλιέργεια:</label>
          <select value={cupt} onChange={handleCuptChange}>
            <option value="Αμπέλι">Αμπέλι</option>
            <option value="Μήλα">Μήλα</option>
            <option value="Αχλάδια">Αχλάδια</option>
            <option value="Μαρούλια">Μαρούλια</option>
            <option value="Πατάτες">Πατάτες</option>
            <option value="Άλλο">Άλλο</option>
          </select>
          <label>Περιοχή:</label>
          <select value={loc} onChange={handleLocChange}>
            <option value="Ζευγολατιό">Ζευγολατιό</option>
            <option value="Μαντινεία">Μαντινεία</option>
            <option value="Νεμέα">Νεμέα</option>
            <option value="Παλλάντιο">Παλλάντιο</option>
            <option value="Κάψια">Κάψια</option>
            <option value="Λουκά">Λουκά</option>
            <option value="Μανθυρέα">Μανθυρέα</option>
            <option value="Τεγέα">Τεγέα</option>
            <option value="Καμάρι">Καμάρι</option>
            <option value="Βουνό">Βουνό</option>
            <option value="Άλλο">Άλλο</option>
          </select>
          <label>Συμβάν:</label>
          <select value={evn} onChange={handleEvnChange}>
            <option value="Βροχή">Βροχή</option>
            <option value="Πάγος">Πάγος</option>
            <option value="Χαλάζι">Χαλάζι</option>
            <option value="Ξηρασία">Ξηρασία</option>
            <option value="Κλάδεμα">Κλάδεμα</option>
            <option value="Ράντισμα">Ράντισμα</option>
            <option value="Ασθένεια">Ασθένεια</option>
            <option value="Βακτήριο">Βακτήριο</option>
            <option value="Άλλο">Άλλη εργασία στην καλλιέργεια</option>
          </select>
          <label>Σχόλια/παρατηρήσεις:</label>
          <textarea rows="4" value={comm} onChange={handleCommChange}/>
          <label>Αρχείο:</label>
          <input type="file" onChange={handleFileChange} />
          <div>
            <button onClick={handleSaveClick}>Αποθήκευση</button>
            <button onClick={handleCloseClick}>Κλείσιμο</button>
          </div>
        </div>
      )}
      {isModified && (
        <div className="popup">
          <h3>Επεξεργασία Συμβάντος</h3>
          <label>Ημερομηνία:</label>
          <input type="date" value={selectedDate} onChange={handleDateChange} />
          <label>Καλλιέργεια:</label>
          <select value={cupt} onChange={handleCuptChange}>
            <option value="Αμπέλι">Αμπέλι</option>
            <option value="Μήλα">Μήλα</option>
            <option value="Αχλάδια">Αχλάδια</option>
            <option value="Μαρούλια">Μαρούλια</option>
            <option value="Πατάτες">Πατάτες</option>
            <option value="Άλλο">Άλλο</option>
          </select>
          <label>Περιοχή:</label>
          <select value={loc} onChange={handleLocChange}>
            <option value="Ζευγολατιό">Ζευγολατιό</option>
            <option value="Μαντινεία">Μαντινεία</option>
            <option value="Νεμέα">Νεμέα</option>
            <option value="Κάψια">Κάψια</option>
            <option value="Λουκά">Λουκά</option>
            <option value="Τεγέα">Τεγέα</option>
            <option value="Καμάρι">Καμάρι</option>
            <option value="Βουνό">Βουνό</option>
            <option value="Άλλο">Άλλο</option>
          </select>
          <label>Συμβάν:</label>
          <select value={evn} onChange={handleEvnChange}>
            <option value="Βροχή">Βροχή</option>
            <option value="Πάγος">Πάγος</option>
            <option value="Χαλάζι">Χαλάζι</option>
            <option value="Ξηρασία">Ξηρασία</option>
            <option value="Κλάδεμα">Κλάδεμα</option>
            <option value="Ράντισμα">Ράντισμα</option>
            <option value="Ασθένεια">Ασθένεια</option>
            <option value="Βακτήριο">Βακτήριο</option>
            <option value="Άλλο">Άλλο πρόβλημα στην καλλιέργεια</option>
          </select>
          <label>Σχόλια/παρατηρήσεις:</label>
          <textarea rows="4" value={comm} onChange={handleCommChange}/>
          <label>Αρχείο:</label>
          <input type="file" onChange={handleFileChange} />
          <div>
            <button onClick={handleUpdateClick}>Ενημέρωση</button>
            <button onClick={handleDeleteClick}>Διαγραφή</button>
            <button onClick={handleCloseClick2}>Κλείσιμο</button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Calendar;